<template>
  <v-container grid-list-xs class="pa-0">
    <v-layout row wrap>
      <v-card class="elevation-4">
        <v-card-title class="info white--text">
          <h2 class="headline">Effects Calculator</h2>
        </v-card-title>
        <v-layout row wrap>
          <v-flex xs12 md5 class="border-right text-xs-center">
            <h3 class="display-1 mt-4 blue--text">Effects</h3>
            <h4 class="headline mt-3 pl-3 pr-3">{{ effects.effect }}</h4>
          </v-flex>
          <v-flex xs12 md5 offset-md1 class="pt-3 pb-3">
            <v-form class="mt-2 mb-2 pa-2">
              <v-layout row wrap>
                <v-flex class="pl-1 xs12 md8">
                  <v-select
                    label="Units"
                    v-model="settings.unitType"
                    :items="settings.unitTypes"
                    @input="update"
                  />
                </v-flex>
                <v-flex class="pl-1 xs12 md4">
                  <v-text-field
                    :label="labels.volume"
                    v-model="settings.volume"
                    @input="update"
                  />
                </v-flex>
                <v-flex class="pl-1 xs12 md8">
                  <v-select
                    label="Chemical"
                    v-model="effects.chemical"
                    :items="effects.chemicals"
                    item-text="name"
                    :return-object="true"
                    @input="update"
                  />
                </v-flex>
                <v-flex class="pl-1 xs12 md4">
                  <v-text-field
                    :label="labels.amount"
                    v-model="effects.amount"
                    @input="update"
                  />
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card>
    </v-layout>
    <AdView id="165" />
    <PCModal />
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import AdView from "@/components/AdView";
import PCModal from "@/components/PCModal";

export default {
  components: { AdView, PCModal },
  data() {
    return {
      labels: {
        amount: "Amount",
        volume: "Volume",
      },
    };
  },
  computed: {
    ...mapGetters({
      effects: "effects/getEffects",
      fc: "fc/getFC",
      settings: "settings/getSettings",
    }),
  },
  methods: {
    ...mapActions({
      initSettings: "settings/initSettings",
      saveSettings: "settings/saveSettings",
    }),
    ...mapMutations({
      calcEffects: "effects/calcEffects",
      setEffects: "effects/setEffects",
      setFC: "fc/setFC",
      setSettings: "settings/setSettings",
    }),
    setLabels() {
      this.labels.volume = `Volume (${
        this.settings.unitType === "Metric" ? "litres" : "gallons"
      })`;
      this.labels.amount = `Amount (${
        this.effects.unitIndex[this.effects.chemical.unitIndex].unit
      })`;
    },
    async update() {
      this.effects.unitIndex = this.effects.unitIndices[this.settings.unitType];
      this.setSettings(this.settings);
      this.setEffects(this.effects);
      this.calcEffects(this.settings);
      this.setLabels();
      this.fc.jugSizes = this.fc.allJugSizes[this.settings.unitType];
      const jugSize = this.fc.jugSizes.filter(
        (j) => j.name === this.fc.jugSize.name
      );
      this.fc.jugSize = jugSize.length < 1 ? this.fc.jugSizes[0] : jugSize[0];
      this.setFC(this.settings);
      await this.saveSettings(this.settings);
    },
  },
  async mounted() {
    await this.initSettings();
    this.effects.unitIndex = this.effects.unitIndices[this.settings.unitType];
    this.calcEffects(this.settings);
    this.setLabels();
  },
};
</script>

<style lang="scss" scoped>
.border-right {
  border-right: 1px solid #d8d8d8;
}
</style>
